module.exports = __webpack_public_path__ + "img/lbalneaves.93a7cab6.png";